import React from 'react';
import { Flex, Checkbox } from '../../../../flayr-components';
import ArrayMap from '../../../../lib/ArrayMap/ArrayMap';

interface IRescheduleOptionsProps {
  changeDate?: boolean;
  changeTime?: boolean;
  onChange?: (e: any) => void;
}

const RescheduleOptions: React.FC<React.PropsWithChildren<React.PropsWithChildren<IRescheduleOptionsProps>>> = (props) => {
  const { onChange } = props;
  const options = [
    { label: 'date', field: 'changeDate' },
    { label: 'time', field: 'changeTime' },
  ];
  return (
    <div>
      <Flex>
        <div className="">
          <p>You can select multiple</p>
        </div>
      </Flex>

      <div className="mt-5">
        <ArrayMap items={options}>
          {(opt) => (
            <label className="flex items-center mb-5">
              <Checkbox
                name={opt.field}
                checked={props[opt.field]}
                onChange={onChange}
              />
              <div className="pl-3 cursor">I need to change {opt.label}</div>
            </label>
          )}
        </ArrayMap>
      </div>
    </div>
  );
};
export default RescheduleOptions;
